import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Reportlist from './report';
import { Button, Divider } from '@mui/material';
import axios from 'axios';
import MainData from './mainData';
import CustomBackdrop from '../../../../../../Components/CustomBackdrop/Barckdrop';
import CustomSnackbar from '../../../../../../Components/Snackbar/Snackbar';
import { genpostURL } from '../../../../../../_getjson';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import PropTypes from 'prop-types';

export default function Reportpremissionnanage(props) {
    const { defaultpermisionData } = props
    const [value, setValue] = React.useState('1');
    const [mainData, setmainData] = React.useState([]);
    const [reportData, setreportData] = React.useState([]);
    const [permisionData, setpermisionData] = React.useState([]);
    const [disabledb_save, setdisabledb_save] = React.useState(true);
    //----------------------------alert ----------------------------
    const [color, setColor] = React.useState("")
    const [opensnackbar, setOpensnackbar] = React.useState(false)
    const [autoClose, setAutoClose] = React.useState(3600)
    const [messagealert, setMessagealert] = React.useState("")
    const [icon, setIcon] = React.useState("")
    const [openbackdrop, setopenbackdrop] = React.useState(false)
    const [listdefaultpermisionDatas, setlistdefaultpermisionDatas] = React.useState([])
    React.useEffect(() => {
        checkData()
        return () => {
        }
    }, [permisionData])

    React.useEffect(() => {
        listData()
        return () => {
        }
    }, [reportData, mainData])
    React.useEffect(() => {
        listdefaultpermisionData()
        return () => {
        }
    }, [])
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const resmainData = (e) => {
        //   console.log("resuserData", e); 
        setmainData(e)

    };
    const resreportData = (e) => {
        console.log("resreportData", e);

        setreportData(e)

    };
    const checkData = (e) => {
        console.log("checkData", permisionData.length);
        if (permisionData.length > 0 && permisionData[0].code !== "") {
            setdisabledb_save(false)
        } else {
            setdisabledb_save(true)
        }
    };
    //start เตรียมข้อมูลไว้เปรียบเทียบกับข้อมูลเลือกใหม่
    const listdefaultpermisionData = async () => {
        console.log("listdefaultpermisionData", defaultpermisionData)
        let elementdata = []
        if (defaultpermisionData.length > 0) {
            defaultpermisionData.forEach(element => {
                elementdata.push({ gcode: element.usergroupcode, rcode: element.id, pvalue: element.id + element.usergroupcode })
            });
        }
        await setlistdefaultpermisionDatas(elementdata)
    }
    //end เตรียมข้อมูลไว้เปรียบเทียบกับข้อมูลเลือกใหม่ 
    const listData = async (e) => {
        setopenbackdrop(true)
        let element = []
        mainData.forEach(melement => {
            reportData.forEach(selement => {
                if (selement.code !== "") {
                    element.push({ gcode: melement.code, rcode: selement.code, pvalue: selement.code + melement.code })
                }
            });
        });

        let arraynew = await element.filter(val => {
            return !listdefaultpermisionDatas.find((val2) => {
                //       console.log("aveonClick elementnew", val.pvalue + ":" + val2.pvalue);
                return val.pvalue.toString() === val2.pvalue.toString()
            })
        });
        await setpermisionData(arraynew)
        await setopenbackdrop(false)
    };
    const SaveData = async (e) => {
        await setopenbackdrop(true)
        // console.log("SaveData", permisionData)
        // return
        const parameter = new URLSearchParams();
        parameter.append("permisionData", JSON.stringify(permisionData));
        let url = "reportmanage/permision?"
        // let url = "/permision?"
        // await axios.post(genpostURL(url), parameter).then(res => {
        await axios.post(genpostURL(url), parameter).then(res => {
            console.log("resdata", res.data);
            if (res.data.status === "success") {
                setMessagealert("บันทึกสำเร็จ")
                setColor("success")
                setOpensnackbar(true)
                setIcon(< CheckCircleOutlineRoundedIcon />)

            }
        }).finally(_ => {
            setmainData([])
            setreportData([])
            setpermisionData([])
            setTimeout(() => {
                props.CloseDialog(false)
            }, 1000);
            setopenbackdrop(false)
        })
    }
    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <Box sx={{ m: 2 }} ><Button variant='contained' onClick={e => SaveData()} color="success" size='small' sx={{ cursor: "pointer" }} disabled={disabledb_save}> บันทึก</Button></Box>
            <Divider />
            <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example">
                        <Tab label="กลุ่มสิทธิ์" value="1" />
                        <Tab label="รายงาน" value="2" />
                    </TabList>
                </Box>
                <TabPanel value="1">
                    <MainData resData={e => resmainData(e)} defaultData={mainData} />
                </TabPanel>
                <TabPanel value="2">
                    <Reportlist resData={e => resreportData(e)} defaultData={reportData} />
                </TabPanel>

            </TabContext>
            <CustomBackdrop open={openbackdrop} />
            <CustomSnackbar place="br"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={messagealert}
                open={opensnackbar}
                closeNotification={() => { setOpensnackbar(false) }}
                close />
        </Box>
    );
}
Reportpremissionnanage.prototype = {
    defaultpermisionData: PropTypes.any
}